import { BasicGaugeChart } from './basicGauge';
import { ShadowGaugeChart } from './shadowGauge';

// eslint-disable-next-line
export default { BasicGaugeChart, ShadowGaugeChart }